export const AUTH_CONFIRM = "authConfirm";
export const CONSTRUCTOR = "constructor";
